<template>
  <div :class="['modal', {'show':show}]">
    <div class="bg-overlay"></div>
    <div class="modal-content">
      <p v-html="msg" class="top-msg" v-if="!showResults"></p>

      <div v-if="rsvps.length && !showResults">
        <div class="txt">
          This user has other active reservations.
          <br/>
          <span v-if="isRefund">Would you like to convert any of these reservations into ride credits?</span>
          <span v-else>Would you like to cancel any of these reservations?</span>
        </div>
        <div class="rsvp-box">
          <label class="rsvp-item" v-for="(rsvp, i) in rsvps" :key="i">
            <input type="checkbox" id="asd" :value="rsvp.id" v-model="selected" />
            <div class="rsvp-info">
              <b>
                Res {{rsvp.id}}
                <b v-if="!isRefund">(Cancel Fee: ${{ parseInt(data.cancelFee) ? rsvp.cancellationFee : 0 }})</b>
                <span>{{rsvp.pickupDate}}</span>
              </b>
              <div>{{rsvp.pickup}} > {{rsvp.dropoff}}</div>
            </div>
          </label>
        </div>
        <a :class="['button cta warning block small', {'disabled secondary':!selected.length}]" href="javascript:;" @click="initRsvpCxl">
          <span v-if="isRefund">Yes, convert the selected reservations</span>
          <span v-else>Yes, cancel the selected reservations</span>
        </a>
        <a class="cancel-btn" href="javascript:;" @click="close">
          No, keep the other reservations
        </a>
      </div>

      <div v-if="showResults">
        <div class="top-msg">
          <span>
            Successfully
            <span v-if="isRefund">credited</span> 
            <span v-else>cancelled</span> 
            <b>Reservation(s) {{ success.join(', ') }}.</b>
          </span>
        </div>
        <a class="button cta warning block small" @click="close">
          {{ $t('rsvpDetails.close') }}
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'cancel-upcoming-modal',
  data () {
    return {
      selected: [],
      success: [],
      fail: [],
      cancellationFee: 0,
      showResults: false
    }
  },
  computed: {
    rsvpId () { return this.$route.params.id },
    cancelUpcoming () { return this.$store.state.cancelUpcoming },
    show () { return this.cancelUpcoming.show },
    msg () { return this.cancelUpcoming.msg },
    rsvps () { return this.cancelUpcoming.rsvps },
    data () { return this.cancelUpcoming.data },
    isRefund ()  { return this.data.refundAsCredits },
  },
  methods: {
    close () {
      this.$store.commit('cancelUpcoming/setCancelData', {show: false})
      this.selected = []
      this.success = []
      this.fail = []
      this.$store.commit('cancelUpcoming/setCancelData', {rsvps: []})
      window.location.reload()
    },
    initRsvpCxl () {
      if (!this.selected.length) return
      this.$store.commit('global/setLoaderData', {show: true, message: ''})
      this.getFee(this.selected[0])
      // this.cancel(this.selected[0])
    },
    getFee (id) {
      let self = this
      self.$sdk.get(`/admin/rsvp/${id}/fee`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) { return }
        self.cancellationFee = parseFloat(r.amount)
        self.cancel(id)
      })
    },
    cancel (id) {
      let self = this
      let chargeFees = self.cancellationFee > 0 ? self.data.cancelFee : 0

      self.$sdk.delete(`/admin/rsvp/${id}`, {
        token: self.$store.state.session.sessionToken,
        notes: self.data.notes,
        noteStatus: self.data.noteStatus,
        chargeFees: chargeFees,
        reason: self.data.reason,
        refundAsCredits: self.data.refundAsCredits
      }, r => {
        if (r.error) {
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: r.error.message
          // })
          self.fail.push(id)
          self.selected.shift()
          if (self.selected.length) self.getFee(self.selected[0])
          else {
            self.$store.commit('global/setLoaderData', {show: false})
            self.showResults = true
          }
          return
        }
        self.success.push(id)
        self.selected.shift()
        if (self.selected.length) self.getFee(self.selected[0])
        else {
          self.$store.commit('global/setLoaderData', {show: false})
          self.showResults = true
        }
      })
    },
  },
  watch: {
    rsvpId (val) {
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  resize: vertical;

  .bg-overlay{
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .modal-content{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 400px;
    min-height: 150px;
    border-radius: 6px;
    padding: 20px;
    margin: auto;
    box-shadow: 1px 1px 5px 1px rgba(0,0,0, .3);
    display: none;
  }
  &.show{
    display: flex;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .15s ease-out;
      -moz-animation: slide-down .15s ease-out;
    }
  }
}

.top-msg{
  padding: 10px 5px;
  background: #edffed;
  border: 1px solid #53b34f;
  border-radius: 4px;
  font-size: 15px;
  text-align: center;
}

.rsvp-box{
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 250px;
  overflow: auto;
  margin-bottom: 10px;
}
.rsvp-item{
  padding: 7px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  cursor: pointer;

  &:hover{
    background: #f6f6f6;
  }
  input{
    padding: 0;
    margin: 0;
    width: auto;
  }
}
.rsvp-info{
  width: 100%;
  padding-left: 10px;
  line-height: 1;
  font-size: 14px;
  text-align: left;

  b{
    margin-bottom: 2px;
    font-size: 18px;
    color: #2f3547;

    b{
      font-size: 15px;
      font-weight: 500;
      vertical-align: 3px;
      margin-left: 3px;
      color: #d64343;
    }
    span{
      color: #999;
      font-weight: 500;
      font-size: 14px;
      display: block;
      margin: 3px 0;
    }
  }
  div{
    text-align: left;
  }
}
.txt{
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #2f3547;
  margin-bottom: 8px;
}
.button.warning{
  margin: 15px 0 10px;

  &.disabled{
    // background: #999;
    cursor: not-allowed!important;
  }
}
.cancel-btn {
  display: block;
  text-align: center;
  margin-top: 5px;

  &.disabled{
    color: #999;
    cursor: not-allowed!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/App/CancelUpcomingModal.vue